import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearGroupByVulns, newGetVulns, setGroupByVulns, setPage } from 'store/Manage/filterActions';
import { deleteSelectedVulns, hideVulnModalDelete, redirectToVulnDetail, showVulnModalDelete, showVulnerabilityDetail } from 'store/Manage/actions';
import { selectPage, selectRowsPerPage, selectGroupByField, selectGroupBy } from 'store/Filters/selectors';
import {
  selectVulnsSelected,
  selectShowDetail,
  selectVulnsCount,
  selectShowDeleteConfirmation,
  selectSelectAll,
  selectIsFetching
} from 'store/Manage/selectors';
import { Wrapper, LeftGroup, RightGroup, Separator, Group } from 'Common/Components/CustomActionBar/styled';
import Pagination from 'Common/Components/Pagination';
import CreateActions from 'Screens/Contextualization/Manage/components/CreateActions';
import DeleteConfirmationModal from '../DeleteConfirmationModal';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import GroupFieldSelector from '../GroupFieldSelector';
import FilterSideBarIcon from '../FilterSidebarIcon';

import TagButton from '../TagButton';
import RefreshButton from '../RefreshButton';
import AddRemoveColumnsButton from '../AddRemoveColumnsButton';
import CopyLink from '../CopyLink';
import CopyApiLink from '../CopyApiLink';
import Severity from '../Severity';
import Status from '../Status';
import AddNewEvidence from '../AddNewEvidence';
import SaveAsTemplate from '../SaveAsTemplate';
import ApplyTemplate from '../ApplyTemplate';
import { selectManageFields } from 'store/Preferences/manage/contextSelectors';
import { resetDefault, setFieldVisibility, setNewOrderColumns } from 'store/Preferences/vulnsGeneral/actions';
import ExportCSV from '../ExportCSV';

const ActionBar = ({ setFF, entity }) => {
  const dispatch = useDispatch();
  const vulnsSelected = useSelector(selectVulnsSelected);
  const vulnsCount = useSelector(selectVulnsCount);
  const showVulnDetail = useSelector(selectShowDetail);
  const page = useSelector((state) => selectPage('vulns', state));
  const rowsPerPage = useSelector((state) => selectRowsPerPage('vulns', state));
  const isGrouping = useSelector((state) => selectGroupByField('vulns', state));
  const hasVulns = vulnsCount > 0;
  const onPrev = () => dispatch(setPage(page - 1));
  const onNext = () => dispatch(setPage(page + 1));
  const fields = useSelector(selectManageFields);
  const showDeleteConfirmation = useSelector(selectShowDeleteConfirmation);
  const selectAll = useSelector(selectSelectAll);
  const isFetching = useSelector(selectIsFetching);
  const groupBy = useSelector((state) => selectGroupBy('vulns', state));
  const updateFieldVisibility = async (fieldObj, value, type) => {
    await dispatch(setFieldVisibility(fieldObj, value, type));
    dispatch(newGetVulns());
  };
  const resetColumns = async () => {
    await dispatch(resetDefault());
    dispatch(newGetVulns());
  };

  return (
    <Wrapper data-tour="Toolbar Vulnerabilities">
      { showDeleteConfirmation
        ? <DeleteConfirmationModal
            showDeleteConfirmation={ showDeleteConfirmation }
            selectAll={ selectAll }
            isFetching={ isFetching }
            vulnsSelected={ vulnsSelected }
            deleteVulns={ () => dispatch(deleteSelectedVulns()) }
            hideModalDelete={ () => dispatch(hideVulnModalDelete()) }
            vulnsCount={ vulnsCount }
        />
        : null
      }
      <LeftGroup>
        <CreateActions entity={ entity } />
        <Separator />
        <Group>
          <EditButton hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } openVulnDetail={ (vulnId) => dispatch(redirectToVulnDetail(vulnId)) } />
          <TagButton setFF={ setFF } hasItems={ hasVulns } />
          <CopyLink hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } />
          <CopyApiLink hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } entity={ entity } />
          <Severity hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } entity={ entity } />
          <Status hasVulns={ hasVulns } groupBy={ isGrouping } vulnsSelected={ vulnsSelected } entity={ entity } />
          <AddNewEvidence hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } openEvidenceTab={ (vulnId) => dispatch(showVulnerabilityDetail(vulnId, 'evidence')) } entity={ entity } />
          <SaveAsTemplate hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } entity={ entity } />
          <ApplyTemplate hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } entity={ entity } />
          <DeleteButton hasVulns={ hasVulns } vulnsSelected={ vulnsSelected } showVulnDetail={ showVulnDetail } showModalDelete={ () => dispatch(showVulnModalDelete()) } entity={ entity } />

        </Group>
      </LeftGroup>

      <RightGroup>

        { hasVulns && <GroupFieldSelector groupBy={ groupBy } setGroupBy={ (groupBy) => dispatch(setGroupByVulns(groupBy)) } clearGroupBy={ () => dispatch(clearGroupByVulns()) } /> }

        { <Pagination offset={ (hasVulns && !isGrouping) ? page : null } limit={ rowsPerPage } total={ vulnsCount } onPrev={ onPrev } onNext={ onNext } />}

        { hasVulns && <Separator /> }

        <Group>
          { hasVulns && <ExportCSV /> }
          <RefreshButton entity={ entity } />
          <FilterSideBarIcon entity="vulns" />
          <AddRemoveColumnsButton
            fields={ fields }
            setFieldVisibility={ updateFieldVisibility }
            setNewOrderColumns={ (columns) => dispatch(setNewOrderColumns(columns)) }
            resetDefault={ resetColumns }
          />
        </Group>
      </RightGroup>
    </Wrapper>
  );
};

export default ActionBar;
